// MediaBuying views
import MediaBuying from '@/views/MediaBuying.vue';
import MediaBuyingReports from '@/views/MediaBuying/MediaBuyingReports.vue';
import MediaBuyingBlacklist from '@/views/MediaBuying/MediaBuyingBlacklist.vue';
import MediaBuyingUnreportedFunds from '@/views/MediaBuying/MediaBuyingUnreportedFunds.vue';
import MediaBuyingTransfer from '@/views/MediaBuying/MediaBuyingTransfer.vue';
import MediaBuyingList from '@/views/MediaBuying/MediaBuyingList.vue';
import MediaBuyingPostsList from '@/views/MediaBuying/MediaBuyingPostsList.vue';
import MediaBuyingPaymentsInfo from '@/views/MediaBuying/MediaBuyingPaymentsInfo.vue';
import MediaBuyingPostInfo from '@/views/MediaBuying/MediaBuyingPostInfo.vue';
import MediaBuyingBlacklistUrls from '@/views/MediaBuying/MediaBuyingBlacklistUrls.vue';

export default [
  {
    path: '/media-buying',
    name: 'media_buying',
    component: MediaBuying,
    meta: {
      requiresAuth: true,
      view: 'media-buying',
    },
    children: [
      {
        path: 'blacklist',
        component: MediaBuyingBlacklist,
        name: 'media_buying.blacklist',
        meta: {
          view: 'blacklist',
          permission: {},
        },
      },
      {
        path: 'blacklist-urls',
        component: MediaBuyingBlacklistUrls,
        name: 'media_buying.blacklist_urls',
        meta: {
          view: 'blacklist_urls',
          permission: {},
        },
      },
      {
        path: 'reports',
        component: MediaBuyingReports,
        name: 'media_buying.reports',
        meta: {
          view: 'reports',
          freeWrapper: true,
          permission: {
            list: ['media_buying.reports_view'],
          },
        },
      },
      {
        path: 'unreported-funds',
        component: MediaBuyingUnreportedFunds,
        name: 'media_buying.overview',
        meta: {
          view: 'unreported_funds',
          permission: {
            list: ['media_buying_reports_view'],
          },
        },
      },
      {
        path: 'transfer',
        component: MediaBuyingTransfer,
        name: 'media_buying_transfer',
        meta: {
          view: 'transfer',
          permission: {
            list: ['media_buying_reports_view'],
          },
        },
      },
      {
        path: 'payments-moderation/on-review',
        component: MediaBuyingList,
        name: 'media_buying.payments_moderation_review',
        meta: {
          view: 'on_review',
          group: 'media_buying_payments_moderation',
        },
      },
      {
        path: 'payments-moderation/for-rework',
        component: MediaBuyingList,
        name: 'media_buying.payments_moderation_for_rework',
        meta: {
          view: 'for_rework',
          group: 'media_buying_payments_moderation',
        },
      },
      {
        path: 'payments-moderation/approved',
        component: MediaBuyingList,
        name: 'media_buying.payments_moderation_approved',
        meta: {
          view: 'approved',
          group: 'media_buying_payments_moderation',
        },
      },
      {
        path: 'payments-moderation/declined',
        component: MediaBuyingList,
        name: 'media_buying.payments_moderation_declined',
        meta: {
          view: 'declined',
          group: 'media_buying_payments_moderation',
        },
      },
      {
        path: 'payments-payout/not-paid',
        component: MediaBuyingList,
        name: 'media_buying.payments_payout_not_paid',
        meta: {
          view: 'not_paid',
          group: 'media_buying_payments_payout',
        },
      },
      {
        path: 'payments-payout/for-rework',
        component: MediaBuyingList,
        name: 'media_buying.payments_payout_for_rework',
        meta: {
          view: 'for_rework',
          group: 'media_buying_payments_payout',
        },
      },
      {
        path: 'payments-payout/processing',
        component: MediaBuyingList,
        name: 'media_buying.payments_payout_processing',
        meta: {
          view: 'processing',
          group: 'media_buying_payments_payout',
        },
      },
      {
        path: 'payments-payout/paid',
        component: MediaBuyingList,
        name: 'media_buying.payments_payout_paid',
        meta: {
          view: 'paid',
          group: 'media_buying_payments_payout',
        },
      },
      {
        path: 'payments-payout/failed',
        component: MediaBuyingList,
        name: 'media_buying.payments_payout_failed',
        meta: {
          view: 'failed',
          group: 'media_buying_payments_payout',
        },
      },
      {
        path: 'payments/:id',
        component: MediaBuyingPaymentsInfo,
        name: 'media_buying.info',
      },
      {
        path: 'posts/on-review',
        component: MediaBuyingPostsList,
        name: 'media_buying.posts_on_review',
        meta: {
          view: 'on_review',
        },
      },
      {
        path: 'posts/for-rework',
        component: MediaBuyingPostsList,
        name: 'media_buying.posts_for_rework',
        meta: {
          view: 'for_rework',
        },
      },
      {
        path: 'posts/approved',
        component: MediaBuyingPostsList,
        name: 'media_buying.posts_approved',
        meta: {
          view: 'approved',
        },
      },
      {
        path: 'posts/declined',
        component: MediaBuyingPostsList,
        name: 'media_buying.posts_declined',
        meta: {
          view: 'declined',
        },
      },
      {
        path: 'posts/:id',
        component: MediaBuyingPostInfo,
        name: 'media_buying.post_info',
      },
      {
        path: '',
        name: 'media_buying.empty',
        redirect: {
          name: 'media_buying.payments_moderation_review',
        },
      },
      {
        path: ':catchAll(.*)',
        name: 'media_buying.catch-all',
        redirect: {
          name: 'media_buying.payments_moderation_review',
        },
      },
    ],
  },
];
